import * as React from "react";
import { tv } from "tailwind-variants";
import { cn } from "@repo/utils/cn";
import { ComponentProps } from "react";
import { Title, TitleProps } from "./Title";
import { sectionWrapper } from "./sectionWrappers";

const infoBlockContainer = tv({
  base: cn(
    "uipm:flex uipm:flex-col",
    "uipm:max-w-[920px] uipm:mx-auto",
    "uipm:py-[var(--container-card-medium-padding)] uipm:px-[var(--container-margin)]",
    "uipm:md:rounded-[var(--radius-lg)]"
  ),
  variants: {
    backgroundColor: {
      primary: "uipm:bg-[var(--surface-surface-accent)]",
      secondary: "uipm:bg-[var(--surface-surface-accent-secondary)]",
      "secondary-light": "uipm:bg-[var(--surface-surface-accent-light)]",
      light: "uipm:bg-[var(--surface-surface-secondary)]",
      white: "uipm:bg-[var(--surface-surface-primary)]",
      none: "",
    },
  },
  defaultVariants: {
    backgroundColor: "none",
  },
});

const typographyContainer = tv({
  base: cn(
    "uipm:flex uipm:flex-col uipm:pr-[var(--container-card-medium-padding)] uipm:gap-6"
  ),
});

type BackgroundColorType =
  | "primary"
  | "secondary"
  | "secondary-light"
  | "light"
  | "white"
  | "none";

export interface InfoBlockProps
  extends Omit<ComponentProps<"section">, "title"> {
  title?: TitleProps | null;
  text?: React.ReactNode;
  backgroundColor?: BackgroundColorType;
  topPadding?: "none" | "default" | "large";
  bottomPadding?: "none" | "default";
  pageType?: "default" | "location";
}

export const InfoBlock: React.FC<InfoBlockProps> = ({
  title,
  text,
  backgroundColor = "none",
  topPadding = "default",
  bottomPadding = "default",
  pageType = "default",
  className,
  id,
  ...props
}) => {
  return (
    <section
      id={id}
      className={cn(
        sectionWrapper({
          backgroundColor: "none",
          topPadding,
          bottomPadding,
          pageType,
        })
      )}
      {...props}
    >
      <div className={cn(infoBlockContainer({ backgroundColor }), className)}>
        <div className={typographyContainer()}>
          {title && <Title {...title} />}
          {text && <div>{text}</div>}
        </div>
      </div>
    </section>
  );
};
